import {Component, Input} from '@angular/core';
import {ProductionScheduleGlobalStatus} from '@domain/production-schedule/production-schedule-global-status.enum';
import {ProductionScheduleState} from '@domain/production-schedule/production-schedule-state';
import {ProductionScheduleStatus} from '@domain/production-schedule/production-schedule-status.enum';
import {TranslateService} from '@vdw/angular-component-library';

@Component({
  selector: 'app-production-schedule-status-icon',
  templateUrl: './production-schedule-status-icon.component.html',
  styleUrls: ['./production-schedule-status-icon.component.scss']
})
export class ProductionScheduleStatusIconComponent {
  @Input() public withNewIcons = false;
  @Input() public withSmallSize = false;
  @Input() public withTooltip = false;
  @Input() public status: ProductionScheduleStatus;
  @Input() public state: ProductionScheduleState;

  public constructor(private readonly translate: TranslateService) {}

  public getIconNameForProductionScheduleStatus(): string {
    return this.state ? ProductionScheduleGlobalStatus.getStatusIconName(this.state.globalStatus, this.withNewIcons) : ProductionScheduleStatus.getStatusIconName(this.status);
  }

  public getIconColorNameForProductionScheduleStatus(): string {
    return this.state ? this.state.statusColor.toLowerCase() : '';
  }

  public getTooltip(): string {
    return this.withTooltip ? this.translate.instant(`PRODUCTION_ORDER.STATUS.${this.status}`) : null;
  }
}
